import FeedBack from '@/types/feedBack';
import { FeedBackStateInterface } from './types';

export default {
  setFeedBack(
    state: FeedBackStateInterface,
    feedBack: FeedBack
  ) {
    state.feedBack = feedBack;
  }
};
